import styled from "styled-components";
import Card from '@material-ui/core/Card';
import { Title } from '../title/Title';

export const CardStyled = styled(({ margin, color, padding, ...props }) => (
    <Card {...props} />
))`
    padding: ${props => `${props.padding || '0px'}`}; 
    transition: 0.2s ease-in;
    && {   
        background-color: ${props => props.color || '#FFFFFF'} ;
        border-radius: 8px;  
        margin: ${props => props.margin || '0px'} ; 
    }
`;

export const TitleCard = styled(Title)`  
    transition: 0.2s ease-in;
    @media (max-width: 1000px) {
        font-size: 14px;
        transition: 0.2s ease-in;
    }
`;
